exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-4250b3b2]{width:100%;max-width:1550px}.table-responsive[data-v-4250b3b2]{overflow-x:auto}.fa-stack[data-v-4250b3b2]{font-size:.65em}i[data-v-4250b3b2]{vertical-align:middle}.columns.column-blanco[data-v-4250b3b2]{padding-bottom:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4250b3b2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checklist_Componentes/Historia.vue
// module id = 2890
// module chunks = 0